var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',{staticClass:"mr-2",attrs:{"type":"warning","size":"sm"},on:{"click":_vm.handleClick}},[_c('i',{staticClass:"fa fa-edit fa-fw"}),_vm._v("Modificar\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }